<template>
    <modal
        name="delete-employee-form"
        class="modal--translation"
        v-cloak height="auto"
        :scrollable="false"
        :adaptive="false"
        :pivot-y="0.25"
    >
        <!-- Error message display -->
        <div v-if="showError" class="error-message">
            <div class="modal-header">
                <button @click="closeModal()" type="button" class="close close-modal mr-2"><i class="fal fa-fw fa-times"></i></button>
            </div>

            <div class="d-flex align-items-center justify-content-center text-danger mb-3">
                <i class="fal fa-times-circle fa-4x mr-3"></i>
                <h3>{{ errorTitle }}</h3>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-md-12 mx-2">
                        <p class="text-center">{{ errorMessage }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!showError">
            <div class="modal-header">
                <button @click="closeModal()" type="button" class="close close-modal mr-2"><i class="fal fa-fw fa-times"></i></button>

                <h5 class="modal-title mb-0"><i class="fa fa-exclamation-triangle mr-2"></i> {{ trans('title') }}</h5>
            </div>

            <div class="modal-body p-0" :class="{'loading': loading }">
                <div class="row">
                    <div class="col-md-12">
                        <h6 v-if="mutEmployeeName" class="head-title mb-4">
                            <i class="far fa-user mr-2"></i>
                            {{ mutEmployeeName }}
                        </h6>

                        <p>{{ trans('description') }}</p>

                        <form class="mt-4">
                            <div class="form-group">
                                <input class="form-check-input" type="checkbox" :id="'delete_confirmation_' + this.mutEmployeeId" v-model="checked" :value="checked">
                                <label class="form-check-label" :for="'delete_confirmation_' + this.mutEmployeeId">{{ trans('delete_mymcd') }}</label>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div class="modal-footer text-center">
                <b-button type="button" variant="danger" @click="submitForm()" :class="{'loading disabled': loading }"><i class="fa fa-check mr-2"></i> {{ trans('submit') }}</b-button>
            </div>
        </div>
    </modal>
</template>


<script>
import TranslationsUtils from "../../app-components/TranslationsUtils";
export default {
    mixins: [TranslationsUtils],

    props: {
        'baseUrl': {
            type: String
        },
        'employeeId': {
            type: Number
        },
        'onsuccess': {
            type: Function
        },
    },

    data: function() {
        return {
            loading: false,
            checked: true,
            mutEmployeeId: this.employeeId,
            mutEmployeeName: '',
            mutBaseUrl: this.baseUrl,
            errorMessage: "",
            errorTitle: "",
            showError: false
        };
    },

    methods: {
        open(id, fullName) {
            //this.showError = !isDeleteable;
            //this.errorMessage = !isDeleteable ? this.trans('error_related_data') : "";
            this.mutEmployeeId = id;
            this.mutEmployeeName = fullName ? fullName : '';
            this.mutBaseUrl = this.baseUrl.replace('__id__', id);
            this.$modal.show('delete-employee-form');
        },

        submitForm() {
            this.loading = true;

            axios.delete(this.mutBaseUrl, {data: { id: this.mutEmployeeId, deletable: this.checked } })
                .then(success => {
                    this.closeModal();
                    this.$notify({ type: 'success', title: success.data.message, text: success.data.error });

                    if(typeof this.onsuccess !== 'undefined') {
                        this.onsuccess();
                    } else {
                        window.location.reload();
                    }
                    this.loading = false;
                })
                .catch(error => {
                    if(error.response) {
                        this.errorTitle = error.response.data.message;
                        this.errorMessage = error.response.data.error;
                    }
                    this.loading = false;
                });
        },

        closeModal() {
            this.$modal.hide('delete-employee-form');
            this.errorTitle = "";
            this.errorMessage = "";
        },
    },
};
</script>

<style lang="scss" scoped>
    .modal-header {
        padding: 0;
        margin: 0;
        margin-bottom: 35px;
        border-bottom: 0;
    }
    h6.head-title {
        margin-bottom: 20px;
        font-size: 1.1rem;
    }
    .modal-footer {
        padding: 0;
        margin-top: 18px;
        border: 0;
    }
    .form-group {
        margin-bottom: 3px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/employee/modals/DeleteEmployeeForm.vue